import { ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

export function plMaxDateValidator(maxDate: DateTime): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let invalid: boolean = false;
    if (control.value) {
      invalid = <DateTime>control.value >= maxDate;
    }
    return invalid ? { plMaxDate: maxDate } : null;
  };
}

export function plMinDateValidator(minDate: DateTime): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let invalid: boolean = false;
    if (control.value) {
      invalid = <DateTime>control.value <= minDate;
    }
    return invalid ? { plMinDate: minDate } : null;
  };
}
